/**
 * Created by Andrey Popov on 12/8/25.
 */

const MultipleView = function (multiple, unitView) {
    this.multiple = multiple;
    this.unitView = unitView;

    this.applyShift();
    this.updateVisibility();
};

MultipleView.prototype.applyShift = function () {
    const position = this.unitView.getPosition();
    const cellSize = cleverapps.styles.Map2dView.cell;
    const shift = this.multiple.calcShift();

    const x = position.x + cellSize.width * (shift.x - shift.y) / 2;
    const y = position.y + cellSize.height * (shift.x + shift.y) / 2;
    this.unitView.setPosition(x, y);
};

MultipleView.prototype.updateVisibility = function (animate) {
    const visible = this.multiple.isUnitVisible();
    if (!visible && animate) {
        this.unitView.stopAllActions();
        this.unitView.runAction(new cc.Sequence(
            new cc.ScaleTo(0.15, 0).easing(cc.easeIn(2)),
            new cc.DelayTime(0.2),
            new cc.CallFunc(() => {
                this.unitView.setVisible(false);
            })
        ));
    } else {
        this.unitView.setVisible(visible);
    }
};